import React from 'react';

import { useSelector } from 'react-redux';

import { magicFieldsDataSelector } from '../../../store/selectors/formSessionSelectors';
import { replaceMagicFields } from '../../ApplicationSentContent/helpers';
import { Typography } from '@hid-galaxy-ui/galaxy-react';
import { TypographyVariantEnum } from '@hid-galaxy-ui/galaxy-react/components/Typography/typographyEnum';

interface IReadOnlyTextProps {
  defaultText: string;
}

const ReadOnlyText = (props: IReadOnlyTextProps) => {
  const magicFieldsData = useSelector(magicFieldsDataSelector);
  const { defaultText } = props;

  const isMagicFieldsData =
    magicFieldsData && Object.keys(magicFieldsData).length > 0;

  return (
    <div className="hid-layout__my-01">
      <Typography variant={TypographyVariantEnum.BodyLongMarketing}>
        {isMagicFieldsData
          ? replaceMagicFields(defaultText, magicFieldsData)
          : defaultText}
      </Typography>
    </div>
  );
};

export default ReadOnlyText;
